import { render } from "./OrderFailed.vue?vue&type=template&id=fa9e10c6&bindings={}"
import script from "./OrderFailed.vue?vue&type=script&lang=js"
export * from "./OrderFailed.vue?vue&type=script&lang=js"
script.render = render

export default script